import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'dicta-vue-components/dist/dicta-vue-components.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
